const VIDEO_SELECTOR = ".js-video"
const VIDEO_MEDIA_BUTTON_SELECTOR = ".js-button-video"
const VIDEO_PLAYED_CLASS = "played"
const HIDDEN_CLASS = "hidden"
const FALLBACK_IMAGE_SELECTOR = ".js-image-fallback"

class HomeVideo extends HTMLElement {
  constructor () {
    super()

    this.rootEl = this.querySelector('.js-home-hero')
    this.wrapperBackgrounds = this.rootEl.querySelectorAll('.js-background-video')
    this.videoMediaButtons = this.querySelectorAll(VIDEO_MEDIA_BUTTON_SELECTOR)
    this.slider = this.querySelector('.js-home-hero-slider')
    this.slides = this.querySelectorAll('.js-home-hero-slide')

    if (this.slider && this.slides.length > 0) {
      this.initSlider(this.slider)
    }

    if (this.wrapperBackgrounds.length > 0) {
      this.wrapperBackgrounds.forEach(wrapper => {
        this.loadVideoEl(wrapper);
      })
    }
  }

  initSlider(slider) {
    const prevButton = this.slider.querySelector('.slideshow-navigation__navigation-button--previous')
    const nextButton = this.slider.querySelector('.slideshow-navigation__navigation-button--next')
    const dots = this.slider.querySelector('.slideshow-navigation__dots')

    import(flu.chunks.swiper /* @vite-ignore */).then(function (_ref) {
      const Swiper = _ref.Swiper
      const Navigation = _ref.Navigation
      const Pagination = _ref.Pagination
      const swiper = new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        pagination: {
          el: dots,
          clickable: true,
          bulletActiveClass: 'slideshow-navigation__dot--active',
          bulletClass: "slideshow-navigation__dot"
        }
      })
    })
  }

  loadVideoEl (wrapper) {
    const videoUrl = wrapper.dataset.url
    const videoCaption = wrapper.dataset.caption
    const posterUrl = wrapper.dataset.poster || ''
    const videoButton = wrapper.parentElement.querySelector(VIDEO_MEDIA_BUTTON_SELECTOR)

    if (videoUrl) {
      const videoWrapper = document.createElement('div')
      videoWrapper.classList.add('video-wrapper')

      const video = document.createElement('video')
      video.classList.add('video', 'js-video')
      video.setAttribute('playsinline', '')
      video.muted = true
      video.setAttribute('loop', '')
      video.setAttribute('autoplay', '')
      video.setAttribute('crossorigin', 'anonymous')
      video.setAttribute('data-state', 'pause')
      if (posterUrl) {
        video.setAttribute('poster', posterUrl)
      }

      const source = document.createElement('source')
      source.setAttribute('src', videoUrl)
      source.setAttribute('type', 'video/mp4')
      video.appendChild(source)

      if (videoCaption) {
        const track = document.createElement('track')
        track.setAttribute('src', videoCaption)
        track.setAttribute('kind', 'subtitles')
        track.setAttribute('srclang', 'en')
        track.setAttribute('label', 'Nightmare')
        track.setAttribute('default', '')
        video.appendChild(track)
      }

      videoWrapper.appendChild(video)
      wrapper.appendChild(videoWrapper)

      video.load()
      this.triggerVideo(video, videoButton)
      video.play().then(() => {
        console.log('Video is playing...')
      }).catch(error => {
        console.error('Error playing video:', error)
      })
    }
  }

  triggerVideo (video, button) {
    if (button) {
      button.addEventListener('click', () => {
        const { state } = video.dataset
        if (state === 'pause') {
          video.pause()
          video.setAttribute('data-state', 'play')
          button.classList.remove('played')
        } else {
          video.play()
          video.setAttribute('data-state', 'pause')
          button.classList.add('played')
        }
      })
    }
  }
}

window.customElements.define("home-hero", HomeVideo)